// Import react elements
import { useEffect, useState } from "react";

// Import components
import CreateButton from "global/components/CreateButton";
import { ImageLoader } from "global/components/ImageLoader";
import TwoColumnList from "global/components/TwoColumnList";



// Render MOCKUP pop up - show larger display image with editable compatibility settings and delete ability
const RenderMockupPopup = ({ isOpen, onClose, mockup, handleUpdateMockup, handleDeleteMockup }) => {

    // Store editable mockup view settings
    const [viewSettings, setViewSettings] = useState({
        aspects: [],
        rotations: []
    });



    // Sync the form when the selected mockup changes
    useEffect(() => {

        // Return early if there is no mockup
        if (!mockup) { return; }

        // Read the supported aspects
        let aspects = [];
        if (Array.isArray(mockup?.view_settings?.aspects)) { aspects = [...mockup.view_settings.aspects]; }

        // Read the supported rotations
        let rotations = [];
        if (Array.isArray(mockup?.view_settings?.rotations)) { rotations = mockup.view_settings.rotations.map((rotation) => Number(rotation)); }

        // Set the editable view settings
        setViewSettings({
            aspects: aspects,
            rotations: rotations
        });

    }, [mockup]);



    // Toggle one supported view setting
    const handleSettingToggle = (settingName, settingValue) => {

        // Update the selected setting list
        setViewSettings((prev) => {

            // Read the current values
            const currentValues = prev[settingName];

            // Check whether this value is already selected
            const valueIsSelected = currentValues.includes(settingValue);

            // Keep at least one value selected in each setting group
            if (valueIsSelected && currentValues.length === 1) { return prev; }

            // Start with the current value list
            let updatedValues = [...currentValues];

            // Remove the selected value
            if (valueIsSelected) {
                updatedValues = updatedValues.filter((currentValue) => currentValue !== settingValue);
            } else {

                // Add the selected value
                updatedValues.push(settingValue);
            }

            // Return the updated settings
            return {
                ...prev,
                [settingName]: updatedValues
            };

        });

    };



    // Render one selectable view setting button
    const renderSettingButton = (settingName, settingValue, label) => {

        // Check whether this setting is selected
        const isSelected = viewSettings[settingName].includes(settingValue);

        // Build the button class
        let buttonClassName = "selectable__chip";
        if (isSelected) { buttonClassName += " selectable__chip--selected"; }

        // Render the option
        return (
            <button type="button" className={buttonClassName} aria-pressed={isSelected} onClick={() => handleSettingToggle(settingName, settingValue)}>
                {label}
            </button>
        );

    };



    // Handle save button click
    const handleSave = () => {

        // Save the mockup view settings
        handleUpdateMockup(mockup, viewSettings);

    };


    // If isOpen is false return early (don't show the pop up)
    if (!isOpen) return null;


    return (

        <div className="popup-overlay">
        
            <div className="popup-container popup-container--small" style={{height: "auto"}}>

                {/* This is the modal header */}
                <div className="popup__header">

                    {/* This is the title area */}
                    <div className="popup__headerLeft">

                        {/* This is the parent title */}
                        <h2 className="popup__title">

                            Mockup

                        </h2>

                        {/* This is the parent subtitle */}
                        <p className="popup__subtitle">
                            {mockup?.id}
                        </p>

                    </div>

                    {/* This is the header actions */}
                    <div className="popup__headerRight">

                        {/* This is the close button */}
                        <button type="button" className="popup__close" onClick={() => onClose?.()} title="Close">
                            🞬
                        </button>

                    </div>

                </div>


                <div className="popup-content popup-content__body">

                    <div className="view-popup_container">

                        <div className="view-popup_image-container">
                            
                            <ImageLoader src={mockup.mockup_image_url} alt="Mockup" className="surface-details_image" wrapperCSS="NA" imageLoaderImageCSS="view_bg-image-NA" />

                        </div>

                    </div>

                    <TwoColumnList
                        property={<label>Aspects</label>}
                        value={
                            <div className="selectable__chips">
                                {renderSettingButton("aspects", "S", "Square")}
                                {renderSettingButton("aspects", "T", "Tall")}
                                {renderSettingButton("aspects", "W", "Wide")}
                            </div>
                        }
                    />

                    <TwoColumnList
                        property={<label>Rotations</label>}
                        value={
                            <div className="selectable__chips">
                                {renderSettingButton("rotations", 0, "0")}
                                {renderSettingButton("rotations", 90, "90")}
                                {renderSettingButton("rotations", 180, "180")}
                                {renderSettingButton("rotations", 270, "270")}
                            </div>
                        }
                    />

                </div>

                <br />

                <div className="tabs-footer tabs-footer--fill-no-background horizontal-align-content-center flex-justify-left-right">

                    <CreateButton title="Delete Mockup" isDelete={true} tooltip="Delete Mockup" size="m" icon="/images/icon_bin.png" onClick={() => handleDeleteMockup(mockup)} />

                    <CreateButton title="Save Mockup" tooltip="Save Mockup" size="m" onClick={handleSave} />

                </div>

            </div>

        </div>
    )

}; export default RenderMockupPopup;